var map = {
	"./C++_Icon.png": 4564,
	"./android_studio_Icon.png": 1994,
	"./angular_icon.png": 1082,
	"./blender_icon.png": 5507,
	"./completed.png": 8217,
	"./django_icon.png": 7190,
	"./events_icon.png": 5097,
	"./express_js.png": 4847,
	"./fast_api.png": 4620,
	"./fitness_icon.png": 4603,
	"./freetime.png": 1356,
	"./friends.png": 4869,
	"./fullscreen_icon.png": 4049,
	"./gallery.png": 1051,
	"./gaming_icon.png": 9610,
	"./gaming_two_icon.png": 3536,
	"./java_icon.png": 161,
	"./linked_in_logo.png": 4316,
	"./movies_series.png": 621,
	"./pause_button.png": 7520,
	"./player_button.png": 4670,
	"./python_icon.png": 1121,
	"./qt_icon.png": 9831,
	"./skills.png": 5297,
	"./software_icon.png": 9339,
	"./spring_boot.png": 5045,
	"./tensorflow_icon.png": 2385,
	"./threed_icon.png": 8214,
	"./travel_icon.png": 3152,
	"./typescript_icon.png": 5600,
	"./unreal_engine_icon.png": 8903,
	"./user.png": 386,
	"./vaadin_icon.png": 9438,
	"./vuejs_icon.png": 5901,
	"./wear_os_icon.png": 6364,
	"./web_icon.png": 4368,
	"./xing_logo.png": 3434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8388;